export default __webpack_public_path__ + "static/rebecca-c9b57d5ae0f9ecf4dadf8d0c1d14024c.png";